import {PartnerCostsState} from './types';

export const initialBusPartnerSpecificCostData = {
  vehicleCost: null,
  vehicleTypeCosts: {
    list: null
  },
  driverCost: null,
  countryCost: null,
  qualityChecked: false
};

export const busPartnerCostData = {
  busPartnersCostYears: null,
  ...initialBusPartnerSpecificCostData
};

export const partnerCostsInitialState: PartnerCostsState = {
  ...busPartnerCostData
};
